import React, { Component } from "react";

export const AppContext = React.createContext({});

export default class ProviderAppContext extends Component {
  state = {
    sumPrice: 0,
    setSumPrice: (value) => {
      this.setState({ sumPrice: value });
    },
    sumPricePayDone: 0,
    setSumPricePayDone: (value) => {
      this.setState({ sumPricePayDone: value });
    },
    resualt: false,
    setResualt: (value) => {
      this.setState({ resualt: value });
    },
    currentMenuTop: "main",
    setCurrentMenuTop: (value) => {
      this.setState({ currentMenuTop: value });
    },
    acUsername: null,
    setAcUsername: (value) => {
      this.setState({ acUsername: value });
    },
    tokenMain: null,
    setTokenMain: (value) => {
      this.setState({ token: value });
    },
    menuMain: [],
    setMenuMain: (value) => {
      this.setState({ token: value });
    },
    modalSession: false,
    setModalSession: (value) => {
      this.setState({ modalSession: value });
    },
    tiggerLotTableBill5: 0,
    setTiggerLotTableBill5: (value) => {
      this.setState({ tiggerLotTableBill5: value });
    },
  };
  render() {
    return (
      <AppContext.Provider value={this.state}>
        {this.props.children}
      </AppContext.Provider>
    );
  }
}

ProviderAppContext.Consumer = AppContext.Consumer;
